




































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Breadcrumb from '@/_shared/components/layout/breadcrumb.component.vue';
import EarningsStatement from '@/earn/entities/earnings/statement/earnings-statement.entity';
import EarningsService from '@/earn/services/earnings.service';
import Rep from '@/_shared/entities/rep/rep.entity';
import DateService from '@/_shared/services/date.service';
import NoResults from '@/_shared/components/globals/no-results.component.vue';
import StatementSummary from '@/earn/components/earnings/statement/statement-summary.component.vue';
import CurrencyService from '@/_shared/services/currency.service';
import Currency from '@/_shared/entities/currency.entity';
import PaygateDetails from '@/earn/components/earnings/statement/paygate-details.component.vue';
import GenerationMatchDetails from '@/earn/components/earnings/statement/generation-match-details.component.vue';
import RedDiamondPoolDetails from '@/earn/components/earnings/statement/red-diamond-pool-details.component.vue';
import DiamondPoolDetails from '@/earn/components/earnings/statement/diamond-pool-details.component.vue';
import TeamBonusDetails from '@/earn/components/earnings/statement/team-bonus-details.component.vue';
import ReturnsDetails from '@/earn/components/earnings/statement/returns-details.component.vue';
import AdjustmentsDetails from '@/earn/components/earnings/statement/adjustments-details.component.vue';
import RetailProfitDetails from '@/earn/components/earnings/statement/retail-profit-details.component.vue';

@Component({
  components: {
    RetailProfitDetails,
    ReturnsDetails,
    TeamBonusDetails,
    RedDiamondPoolDetails,
    DiamondPoolDetails,
    GenerationMatchDetails,
    AdjustmentsDetails,
    NoResults,
    Breadcrumb,
    StatementSummary,
    PaygateDetails,
  },
})
export default class Statement extends Vue {
  statement: EarningsStatement = new EarningsStatement();
  currency: Currency | null = null;
  loading = false;
  showNoStatement = false;

  get rep(): Rep {
    return this.$store.state.RepStore.rep;
  }

  get registerId(): number {
    return Number(this.$route.params.registerId);
  }

  get repName(): string {
    if (this.rep.company !== '') {
      return this.rep.company;
    }

    return `${this.rep.firstName} ${this.rep.lastName}`;
  }

  get statementDate(): string {
    if (!this.statement.startDate && !this.statement.endDate) return '';
    const startDate = DateService.getLocaleFormattedDate(this.statement.startDate);
    const endDate = DateService.getLocaleFormattedDate(this.statement.endDate);
    return this.statement.endDate
      ? `${startDate} - ${endDate}`
      : `${startDate}`;
  }

  get joinDate(): string {
    return DateService.getLocaleFormattedDate(this.statement.joinDate);
  }

  setStatement(): void {
    this.$store.dispatch('showLoading');
    EarningsService.getStatement(this.rep.did, this.registerId)
      .then(async (response) => {
        this.statement = response;
        await this.setCurrency();
      })
      .catch(() => {
        this.showNoStatement = true;
      })
      .finally(() => {
        this.$store.dispatch('hideLoading');
      });
  }

  setCurrency(): void {
    this.$store.dispatch('showLoading');
    CurrencyService.getCurrencyFormatById(this.statement.currencyTypeId)
      .then((response) => {
        this.currency = response;
      })
      .finally(() => {
        this.$store.dispatch('hideLoading');
      });
  }

  print(): void {
    window.print();
  }

  created(): void {
    this.setStatement();
  }
}
